@if (isLoading) {
    <div class="fancy-loader"></div>
} @else {
    <form-linkable
        displayValueProp="name"
        [linkedModule]="linkedModule"
        [linked]="linked"
        [unlinked]="unlinked"
        [disabled]="disabled"
        [hideActions]="true"
        (linkedChange)="linkedItemsChanged($event)"
    ></form-linkable>
}
